import { storeSettings } from './profileActions';
import { SET_SITE_ATTRIBUTES, SiteAttributeAction, SiteAttributesPayloadProps } from './types/attributeActions.d';
import { getSiteAttributes } from '../sdk/AttributeSDK';
import { AppDispatch } from '../store';
import { storeEvidently } from './globalActions';

export const setSiteAttributes = (payload: SiteAttributesPayloadProps): SiteAttributeAction => {
  return {
    type: SET_SITE_ATTRIBUTES,
    payload,
  };
};

export const handleSiteAttributes = (pageName: string) => async (dispatch: AppDispatch) => {
  try {
    const response = await getSiteAttributes(pageName);
    const { captcha, is_eu_user: isEuUser, is_evidently_enabled, experiments, ...restOfData } = response.data;

    dispatch(
      setSiteAttributes({
        ...restOfData,
        isEuUser,
        captcha,
        isMemberCaptchaEnabled: captcha?.source === 'member' && !!captcha,
        isJoinCaptchaEnabled: captcha?.source === 'join' && !!captcha,
        isLoginCaptchaEnabled: captcha?.source === 'login' && !!captcha,
      })
    );

    dispatch(storeSettings({ is_evidently_enabled: is_evidently_enabled || false }));

    if (experiments) {
      await dispatch(storeEvidently({ ...experiments }));
    }
  } catch (error) {
    console.error('Error fetching site attributes', error);
  }
};
